import React from 'react'
import { Link } from 'react-router-dom'
import { Grid } from 'semantic-ui-react'
import ResponsiveImage from '../../components/ResponsiveImage'

import ProjData from './data.json'

class ProjectBox extends React.Component {
  constructor (props) {
    super(props)
    this.state = {over: false}
    this.handleOver = this.handleOver.bind(this)
    this.handleOut = this.handleOut.bind(this)
  }

  handleOver () {
    this.setState({over: true})
  }

  handleOut () {
    this.setState({over: false})
  }

  render () {
    const labelColour = '#222'
    const labelTextColour = this.state.over ? '#FFF' : '#999'
    const src = this.props.data.images[0].src
    const idNum = this.props.data.idNum
    const alt = `Project ${this.props.data.title}`
    return (
      <Link to={`/projects/${idNum}`} onMouseOver={this.handleOver} onMouseOut={this.handleOut}>
        <ResponsiveImage src={'/assets/' + src} alt={alt}/>
        <div style={{height: '30px', backgroundColor: labelColour, color: labelTextColour, padding: '5px 0 6px 6px'}}>
          <p><span>{this.props.data.title}</span><span
            style={{float: 'right', paddingRight: '6px'}}>{this.props.data.year}</span></p>
        </div>
      </Link>
    )
  }
}

const ProjectsGrid = () => {
  let count = 0
  const squares = ProjData.projects.map((data, i) => {
    if (data.images && data.images.length > 0) {
      return (
        <Grid.Column key={'gridSquare' + count++} mobile={16} tablet={8} computer={4}>
          <ProjectBox data={data}/>
        </Grid.Column>
      )
    } else {
      console.log('No images for project' + i)
      return null
    }
  })

  return (
    <Grid>{squares}</Grid>
  )
}

export default ProjectsGrid



// WEBPACK FOOTER //
// ./src/modules/projects/ProjectsGrid.js